import { Box, Flex, Text, useMediaQuery } from "@chakra-ui/react";

export interface ArrowProps {
  bg: string;
  arrowColor: string;
  label: string;
  labelColor: string;
  description: string;
  descriptionColor: string;
  zIndex: number;
  testId?: string;
}

export const ArrowBanner = ({
  bg,
  arrowColor,
  label,
  labelColor,
  testId,
  zIndex,
}: ArrowProps) => {
  const [isSmBp] = useMediaQuery("(min-width: 480px)");
  const [isMdBp] = useMediaQuery("(min-width: 768px)");
  const [isXLBp] = useMediaQuery("(min-width: 1280px)");
  return (
    <Flex
      data-testid={testId}
      flexDir={"column"}
      pb={{
        base: 5,
      }}
      zIndex={zIndex}
      w={"full"}
    >
      <Box
        display="inline-block"
        position="relative"
        background={arrowColor}
        width={"full"}
        height={isXLBp ? "120px" : isMdBp ? "100px" : isSmBp ? "60px" : "40px"}
        top="0"
        left="0"
        lineHeight={
          isXLBp ? "120px" : isMdBp ? "100px" : isSmBp ? "60px" : "40px"
        }
        color="#ffffff"
        fontSize="50px"
        _after={{
          left: "100%",
          border: "solid transparent",
          content: '""',
          height: 0,
          width: 0,
          position: "absolute",
          pointerEvents: "none",
          borderColor: "transparent",
          borderLeftColor: arrowColor,
          borderWidth: `${
            isXLBp ? "60px" : isMdBp ? "50px" : isSmBp ? "30px" : "20px"
          }`,
          top: "50%",
          marginTop: `${
            isXLBp ? "-60px" : isMdBp ? "-50px" : isSmBp ? "-30px" : "-20px"
          }`,
          transform: "scaleX(1.02)",
        }}
        _before={{
          left: "0",
          border: "solid transparent",
          content: '""',
          height: 0,
          width: 0,
          position: "absolute",
          pointerEvents: "none",
          borderColor: "rgba(66, 170, 225, 0)",
          borderLeftColor: bg,
          borderWidth: `${
            isXLBp ? "60px" : isMdBp ? "50px" : isSmBp ? "30px" : "20px"
          }`,
          top: "50%",
          marginTop: `${
            isXLBp ? "-60px" : isMdBp ? "-50px" : isSmBp ? "-30px" : "-20px"
          }`,
          transform: "scaleX(1.02)",
        }}
      >
        <Text
          color={labelColor}
          fontSize={{
            base: 14,
            md: 16,
            lg: 18,
            xl: 22,
          }}
          fontWeight={"bold"}
          pl={{
            base: 6,
            sm: 8,
            md: 16,
            xl: 12,
          }}
          mx="auto"
          w="fit-content"
        >
          {label}
        </Text>
      </Box>
    </Flex>
  );
};
